let getInvoices = function() {
	this.inputFilter = "";
	this.isLoading = true;
	window.billing
	.get("invoices/" + window.localuserdata + this.query)
	.then((response) => {
		this.InvoicesListResult = response.data.result;
		this.pagination = response.data.lista;
		this.InvoicesList = response.data.lista.data;
		let e = this.InvoicesList;
		this.Actionsdropd = [];
		for (var i = 0; i < e.length; i++) {
			this.Actionsdropd[e[i].id] = false;
			if (e[i].idxstatus < 2) {
				this.InvoicesList[i].idxstatus = this.isOverdue(e[i].idxstatus, e[i].fecdue);
			}
		}
		console.log(this.InvoicesList);
		this.OldInvoicesList = this.InvoicesList;
		this.isLoading = false;
	})
	.catch((error) => console.log(error));
};
export default getInvoices;
